import { atom } from 'jotai';
import type { PbmComboVerifyStatus } from '@/types';

export interface PbmComboVerifyState {
  status: PbmComboVerifyStatus;
  savingsTotal: number;
  discountedItemCount: number;
}

export const pbmComboVerifyAtom = atom<PbmComboVerifyState>({
  status: 'idle',
  savingsTotal: 0,
  discountedItemCount: 0,
});
